import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VContainer,
    { attrs: { fluid: "", "grid-list-xl": "" } },
    [
      _c("app-monitoramento", {
        attrs: {
          acesso: _vm.acesso,
          monitoramento: "perfil",
          titulo: _vm.componente ? _vm.componente.titulo : "",
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _vm.componente
                  ? _c(
                      VCol,
                      { attrs: { centered: "", cols: "12", "no-gutters": "" } },
                      [
                        _c(
                          "keep-alive",
                          [_c(_vm.componente.nome, { tag: "component" })],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }